import { render, staticRenderFns } from "./_matchFeed.vue?vue&type=template&id=5b097339&lang=pug&"
import script from "./_matchFeed.vue?vue&type=script&lang=js&"
export * from "./_matchFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports